export default __webpack_public_path__ + "static/media/e5.716d06e8.webp";